import React from 'react';
import { useNavigate } from "react-router-dom";
import FadeInFromLeft from './FadeInFromLeft';
import { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import './Welcome.css';

export default function HeroSection({ isMobile }) {
  const navigate = useNavigate();
  const { isLoggedIn, userRole } = useContext(AuthContext);

  const handleButtonClick = () => {
    if (!isLoggedIn) {
      navigate("/HomePage");
    } else if (userRole === 'student') {
      navigate("/student-dashboard");
    } else if (userRole === 'professor') {
      navigate("/professor-dashboard");
    } else if (userRole === 'admin') {
      navigate("/admin");
    }
  };

  return (
    <main className={`hero-section-stacked ${isMobile ? 'mobile' : ''}`}>
      {/* MISSION RECTANGLE */}
      <FadeInFromLeft>
        <div className={`mission-rectangle ${isMobile ? 'mobile' : ''}`}>
          <div className="rectangle-gradient mission-gradient"></div>
          <div className="rectangle-decoration">
            <div className="floating-circle circle-1"></div>
            <div className="floating-circle circle-2"></div>
            <div className="floating-circle circle-3"></div>
          </div>
          <div className={`rectangle-content ${isMobile ? 'mobile' : ''}`}>
            <div className="mission-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z" fill="currentColor"/>
                <path d="M19 15L20.09 18.26L24 19L20.09 19.74L19 23L17.91 19.74L14 19L17.91 18.26L19 15Z" fill="currentColor"/>
                <path d="M5 15L6.09 18.26L10 19L6.09 19.74L5 23L3.91 19.74L0 19L3.91 18.26L5 15Z" fill="currentColor"/>
              </svg>
            </div>
            <div className={`rectangle-text ${isMobile ? 'mobile' : ''}`}>
              <h3 className={`rectangle-title ${isMobile ? 'mobile' : ''}`}>
                Our Mission
              </h3>
              <p className={`rectangle-description ${isMobile ? 'mobile' : ''}`}>
                To empower every graduate student through personalized support, meaningful connections, and life-changing opportunities.
              </p>
            </div>
          </div>
        </div>
      </FadeInFromLeft>

      {/* VISION RECTANGLE */}
      <FadeInFromLeft delay={isMobile ? 100 : 250}>
        <div className={`vision-rectangle ${isMobile ? 'mobile' : ''}`}>
          <div className="rectangle-gradient vision-gradient"></div>
          <div className="rectangle-decoration">
            <div className="floating-square square-1"></div>
            <div className="floating-square square-2"></div>
            <div className="floating-triangle triangle-1"></div>
          </div>
          <div className={`rectangle-content ${isMobile ? 'mobile' : ''}`}>
            <div className="vision-icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2C13.1 2 14 2.9 14 4C14 5.1 13.1 6 12 6C10.9 6 10 5.1 10 4C10 2.9 10.9 2 12 2ZM21 9V7L15 7.5V9L21 9ZM3 9V7L9 7.5V9L3 9ZM15 9.5V17.5C15 18.3 14.3 19 13.5 19S12 18.3 12 17.5V14.5L10.5 16L9 14.5L12 11.5L15 14.5L13.5 16L12 14.5V17.5C12 18.3 11.3 19 10.5 19S9 18.3 9 17.5V9.5L15 9.5Z" fill="currentColor"/>
              </svg>
            </div>
            <div className={`rectangle-text ${isMobile ? 'mobile' : ''}`}>
              <h3 className={`rectangle-title ${isMobile ? 'mobile' : ''}`}>
                Our Vision
              </h3>
              <p className={`rectangle-description ${isMobile ? 'mobile' : ''}`}>
                To create the largest community of graduate students, fostering innovation and academic excellence worldwide.
              </p>
            </div>
          </div>
        </div>
      </FadeInFromLeft>
    </main>
  );
}
